import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { defaultMeasureCodeIdsToDisplay } from '../../config';

const styles = theme => ({
  input: {
    paddingTop: 0,
    paddingBottom: 2,
  },
  paper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    overflowY: 'hidden',
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  title: {
    display: 'flex',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const withDropdown = (Component) => {
  const hoc = class extends React.Component {
    constructor(props) {
      super(props);

      const { multiple, availableData } = this.props;
      this.state = {
        indexToDisplay: multiple ? defaultMeasureCodeIdsToDisplay : 1,
        filterLabel: multiple ? 'filter'
          : (availableData[0] && availableData[0].label && availableData[0].label.name) || 'No measures',
      };

      this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
      const { indexToDisplay } = this.state;
      const clickedvalue = event.target.value;
      if (clickedvalue === indexToDisplay) return;
      const { multiple, updateValues } = this.props;
      if (multiple) {
        if (clickedvalue.length > 4) return;
        updateValues(clickedvalue);
        this.setState({ indexToDisplay: clickedvalue });
      } else {
        const { availableData } = this.props;
        const dropdownValueToDisplay = availableData.find(
          data => data.pk === event.target.value,
        ).label.name;
        updateValues(clickedvalue);
        this.setState({ filterLabel: dropdownValueToDisplay, indexToDisplay: event.target.value });
      }
    }

    render() {
      const {
        classes,
        title,
        availableData,
        multiple,
      } = this.props;

      const { indexToDisplay, filterLabel } = this.state;
      const isWithDropdown = availableData.length > 0;

      return (
        <div>
          {isWithDropdown && (
            <div className={classes.row}>
              <Typography className={classes.title} variant="subheading">
                {title}
              </Typography>
              <form>
                <FormControl>
                  <Select
                    multiple={multiple}
                    classes={{ select: classes.input }}
                    onChange={this.handleChange}
                    value={indexToDisplay}
                    renderValue={() => filterLabel}
                    displayEmpty
                  >
                    {availableData.map(item => (
                      <MenuItem
                        key={item.pk}
                        className={classes.noTopPadding}
                        value={item.pk}
                      >
                        {item && item.label && item.label.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </form>
            </div>
          )}
          <Component
            {...this.props}
            isWithDropdown={isWithDropdown}
          />
        </div>
      );
    }
  };

  hoc.defaultProps = {
    multiple: false,
  };

  hoc.propTypes = {
    loading: PropTypes.bool.isRequired,
    multiple: PropTypes.bool,
    title: PropTypes.string.isRequired,
    updateValues: PropTypes.func.isRequired,
    data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())]).isRequired,
    availableData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    classes: PropTypes.shape().isRequired,
  };
  return withStyles(styles)(hoc);
};
export default withDropdown;



// WEBPACK FOOTER //
// ./src/components/overview/withDropdown.jsx